// AB#17016: mirrors Trakref.Business TechnicianCertificationValidation, the Service Event technician-dropdown rule enforced at save.
import Enums from "../enums.js";

export const CERTIFICATION_REQUIRED = "Technician Certification Number is required for Technician users.";
export const CERTIFICATION_MIN_LENGTH = "Technician Certification Number must be at least 8 characters.";
export const CERTIFICATION_NINE_DIGIT = "Technician Certification Number cannot be a 9-digit number.";

const { Technician, TechnicianManager, TenantAdministrator, SuperTenantAdmin } = Enums.UserTypes;

// User types whose settings step shows the certification fields.
const CERTIFIED_USER_TYPES = [Technician, TechnicianManager, TenantAdministrator, SuperTenantAdmin];

// Returns the first rule the number breaks, or null; required for Technicians, format-checked for every type that shows the field.
export const getCertificationNumberError = (value, userType) => {
    const type = Number(userType);
    if (!CERTIFIED_USER_TYPES.includes(type)) return null;

    const trimmed = (value ?? "").toString().trim();
    if (!trimmed) return type === Technician ? CERTIFICATION_REQUIRED : null;
    if (trimmed.length < 8) return CERTIFICATION_MIN_LENGTH;

    // Same SSN-shape test as the server: hyphens stripped, then 9 characters that int.TryParse accepts (optional + and edge spaces).
    const withoutHyphens = trimmed.replace(/-/g, "");
    if (withoutHyphens.length === 9 && /^\s*\+?\d+\s*$/.test(withoutHyphens)) return CERTIFICATION_NINE_DIGIT;

    return null;
};
